import React from 'react';
import FormBuscar from './FormBuscar';
import PlayStoreBadge from './PlayStoreBadge';

export default () => {
    const [min, max] = [1, 5];
    const n = Math.floor(Math.random() * (max - min + 1)) + min;
    const bannerStyle = {
        'background': `url('/img/Fondo${n}.jpg') center center no-repeat`
    };
    return (
        <div className='container'>
            <div className='row'>
                <div id='banner' style={bannerStyle}>
                    <div id='publicidad' className='hidden-xs'/>
                    <div className='form-buscar' id='form-buscar-header'>
                        <FormBuscar nombre='q1'/>
                    </div>
                </div>
                <div id='logo-mobile' className='visible-xs'>
                    <a href='/'>La Guía Valentina Quintero</a>
                </div>
                <ul id='main-menu'>
                    <li id='home-link'>
                        <a href='/'>
                            <span className='glyphicon glyphicon-home'/>
                        </a>
                        <div className='estrella'>
                            <span className='glyphicon glyphicon-star'/>
                        </div>
                    </li>
                    <li>
                        <a href='/#/contacto'>
                            <span className='hidden-xs'>Contacto</span>
                            <span className='visible-xs'><i className='fa fa-fw fa-envelope'/></span>
                        </a>
                    </li>
                    {/*<li><a href='http://www.valentinaquintero.com.ve' target='_blank'>Valentina Quintero</a></li>*/}
                    <li><a href='/#/estado/_/rutas/_'>Rutas</a></li>
                    <li><a href='/#/estado/_/pois'>Puntos de Interés</a></li>
                </ul>
                <div id='logo' className='hidden-xs'>
                    <div id='cuadros'>
                        <div id='selva'/>
                        <div id='llano'/>
                        <div id='costa'/>
                        <div id='montana'/>
                    </div>
                    <a href='/' id='imagen_logo'>
                        <img src='/img/logo2.png' alt=''/>
                    </a>
                </div>
                <div className='ocultable hidden-xs' id='contenedo-imagen-header'>
                    <div id='imagen-header' className='jumbotron'>
                        <div id='cuadro-gris2' className='hidden-xs'/>
                        <div id='cuadro-gris' className='hidden-xs'>
                            <h2>&iquest;A dónde quieres ir?</h2>
                            <FormBuscar nombre='q2'/>
                            <div id='posadero-premium'>
                                <a href='/#/contacto'>
                                    Forma parte de nuestros <br/><b>posaderos premium</b>
                                </a>
                            </div>
                            <PlayStoreBadge/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Header.js